import { render, staticRenderFns } from "./mg-mini-pagination.vue?vue&type=template&id=060711fa&scoped=true"
import script from "./mg-mini-pagination.vue?vue&type=script&lang=js"
export * from "./mg-mini-pagination.vue?vue&type=script&lang=js"
import style0 from "./mg-mini-pagination.vue?vue&type=style&index=0&id=060711fa&prod&lang=scss"
import style1 from "./mg-mini-pagination.vue?vue&type=style&index=1&id=060711fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060711fa",
  null
  
)

export default component.exports